<!--使用指南-->
<template>
  <div class="new-home-container">
    <div class="one-row flex ac jb cr">
      <div class="one-row-1" @click="handleJump('/create')"
           :style="{backgroundImage: 'url(' + showList[0].cover + ')', backgroundRepeat:'no-repeat'}"></div>
      <div class="one-row-2 flex ac jb" :style="{ backgroundColor: theme.id== 2 ? '#F0F3F7' : ''}">
        <div class="left-app">
          <p class="pp1" :style="{ color: theme.id== 2 ? '#222222' : ''}">创作宠物视频</p>
          <p class="pp2" :style="{ color: theme.id== 2 ? '#222222AA' : ''}">毛孩专属片场，趣味视频轻松创造</p>
          <p class="pp3 cr" :style="{ backgroundColor: theme.id== 2 ? '#6C14FF' : ''}"
             @click="handleJump('/pet')">立即创作</p>
        </div>
        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic2.png" alt="">
      </div>
      <div class="one-row-2 flex ac jb" :style="{ backgroundColor: theme.id== 2 ? '#F0F3F7' : ''}">
        <div class="left-app">
          <p class="pp1" :style="{ color: theme.id== 2 ? '#222222' : ''}">照片说话</p>
          <p class="pp2" :style="{ color: theme.id== 2 ? '#222222AA' : ''}">可以让照片动起来的神奇工具</p>
          <p class="pp3 cr" :style="{ backgroundColor: theme.id== 2 ? '#6C14FF' : ''}"
             @click="handleJump('/store/imageSpeak',2)">立即创作</p>
        </div>
        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Banner_3.png" alt="">
      </div>
    </div>

    <div class="two-row flex ac jb">
      <div class="towRow-part">
        <p class="title" :style="{ color: theme.id== 2 ? '#222222' : ''}">爆款文案</p>
        <div class="all-info-box flex ac jb" :style="{ backgroundColor: theme.id== 2 ? '#F2F2F2' : ''}">
          <div class="every-info-box flex ac cr" :style="{ backgroundColor: theme.id== 2 ? '#ffffff' : ''}"
               v-for="(item,index) in showList.slice(3,6)" :key="index" @click="handleJump2(item)">
            <img :src="item.cover" alt="">
            <div class="text-info-box">
              <p class="text1" :style="{ color: theme.id== 2 ? '#333333' : ''}">{{item.text1}}</p>
              <p class="text2" :style="{ color: theme.id== 2 ? '#333333AA' : ''}">{{item.text2}}</p>
              <img class="go-icon" v-if="item.can==0"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_1.png" alt="">
              <img class="go-icon" v-else
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_2.png" alt="">
            </div>
            <div class="jqqd-box" v-if="item.can==0">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_1jqqd.png" alt="1">
            </div>
          </div>
        </div>
      </div>
      <div class="towRow-part">
        <p class="title" :style="{ color: theme.id== 2 ? '#222222' : ''}">AI图/视频</p>
        <div class="all-info-box flex ac jb" :style="{ backgroundColor: theme.id== 2 ? '#F2F2F2' : ''}">
          <div class="every-info-box flex ac cr" :style="{ backgroundColor: theme.id== 2 ? '#ffffff' : ''}"
               v-for="(item,index) in showList.slice(6,9)" :key="index" @click="handleJump2(item)">
            <img :src="item.cover" alt="">
            <div class="text-info-box">
              <p class="text1" :style="{ color: theme.id== 2 ? '#333333' : ''}">{{item.text1}}</p>
              <p class="text2" :style="{ color: theme.id== 2 ? '#333333AA' : ''}">{{item.text2}}</p>
              <img class="go-icon" v-if="item.can==0"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_1.png" alt="">
              <img class="go-icon" v-else
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_2.png" alt="">
            </div>
            <div class="jqqd-box" v-if="item.can==0">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_1jqqd.png" alt="1">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="two-row flex ac jb">
      <div class="towRow-part">
        <p class="title" :style="{ color: theme.id== 2 ? '#222222' : ''}">提取文件</p>
        <div class="all-info-box flex ac jb" :style="{ backgroundColor: theme.id== 2 ? '#F2F2F2' : ''}">
          <div class="every-info-box flex ac cr" :style="{ backgroundColor: theme.id== 2 ? '#ffffff' : ''}"
               v-for="(item,index) in showList.slice(9,12)" :key="index" @click="handleJump2(item)">
            <img :src="item.cover" alt="">
            <div class="text-info-box">
              <p class="text1" :style="{ color: theme.id== 2 ? '#333333' : ''}">{{item.text1}}</p>
              <p class="text2" :style="{ color: theme.id== 2 ? '#333333AA' : ''}">{{item.text2}}</p>
              <img class="go-icon" v-if="item.can==0"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_1.png" alt="">
              <img class="go-icon" v-else
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_2.png" alt="">
            </div>
            <div class="jqqd-box" v-if="item.can==0">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_1jqqd.png" alt="1">
            </div>
          </div>
        </div>
      </div>
      <div class="towRow-part">
        <p class="title" :style="{ color: theme.id== 2 ? '#222222' : ''}">音频处理</p>
        <div class="all-info-box flex ac jb" :style="{ backgroundColor: theme.id== 2 ? '#F2F2F2' : ''}">
          <div class="every-info-box flex ac cr" :style="{ backgroundColor: theme.id== 2 ? '#ffffff' : ''}"
               v-for="(item,index) in showList.slice(12,15)" :key="index" @click="handleJump2(item)">
            <img :src="item.cover" alt="">
            <div class="text-info-box">
              <p class="text1" :style="{ color: theme.id== 2 ? '#333333' : ''}">{{item.text1}}</p>
              <p class="text2" :style="{ color: theme.id== 2 ? '#333333AA' : ''}">{{item.text2}}</p>
              <img class="go-icon" v-if="item.can==0"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_1.png" alt="">
              <img class="go-icon" v-else
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_Icon_Arrow_2.png" alt="">
            </div>
            <div class="jqqd-box" v-if="item.can==0">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/21_1jqqd.png" alt="1">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {gguide} from '../api/user'

  const urlDir = 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/'

  export default {
    name: '',
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        // showList: [],
        showList: [
          {id: 0, path: '/create', cover: `${urlDir}21_Banner_1.png`, can: 1, text1: '', text2: ''},
          {id: 1, path: '/pet', cover: `${urlDir}21_Banner_2.png`, can: 1, text1: '', text2: ''},
          {id: 2, path: '/store/imageSpeak', cover: `${urlDir}21_Banner_3.png`, can: 1, text1: '', text2: ''},

          {id: 3, path: '/explosiveAnalysis', cover: `${urlDir}21_Pic_4.png`, can: 1, text1: '超级复刻(Beta)', text2: '带你解锁超级账户'},
          {id: 4, path: '/store/aiChat', cover: `${urlDir}21_Pic_5.png`, can: 2, text1: 'Deepseek(Beta)', text2: 'AI智造专属文案'},
          {id: 5, path: '', cover: `${urlDir}21_Pic_6.png`, can: 0, text1: '专属文案', text2: '精彩故事随心创'},
          {id: 6, path: '/store/wsImage', cover: `${urlDir}21_Pic_1.png`, can: 1, text1: '文生图(Beta)', text2: '告别绘画零基础'},
          {id: 7, path: '/store/wsVideo', cover: `${urlDir}21_Pic_2.png`, can: 2, text1: '文生视频', text2: '精彩视频即刻现'},
          {id: 8, path: '/store/tsVideo', cover: `${urlDir}21_Pic_3.png`, can: 1, text1: '图生视频', text2: '精彩故事随心创'},

          {id: 9, path: '/store/extraction', cover: `${urlDir}21_Pic_7.png`, can: 1, text1: '视频提取', text2: '智能识别水印并消除'},
          {id: 10, path: '/store/audioExtraction', cover: `${urlDir}21_Pic_8.png`, can: 1, text1: '音频提取', text2: '快速提取链接音频'},
          {id: 11, path: '/store/copywrite/trace', cover: `${urlDir}21_Pic_9.png`, can: 1, text1: '文案提取', text2: '智能识别/一键转化'},

          {id: 12, path: '/store/dubbing/index', cover: `${urlDir}21_Pic_10.png`, can: 1, text1: '配音创作', text2: '声创魔法的魅力'},
          {id: 13, path: '/store/music/index', cover: `${urlDir}21_Pic_11.png`, can: 1, text1: '音乐创作', text2: 'AI智配，声动人心'},
          {id: 14, path: '/store/sea', cover: `${urlDir}21_Pic_12.png`, can: 2, text1: '视频翻译', text2: '支持多国语言'},
        ],
        // showList2: [],
      }
    },
    created() {
      // if (this.theme.id == 2) {
      //   this.showList = this.showList1
      // } else {
      //   this.showList = this.showList1
      // }
    },
    methods: {
      handleJump(val,num) {
        if(num==2){
          this.$message.error('维护中暂未开放')
          return false
        }
        this.$router.push({
          path: val,
        })
      },
      handleJump2(item) {
        if(item.can==1){
          this.$router.push({
            path: item.path,
          })
        }
        if(item.can==2){
          this.$message.error('维护中暂未开放')
          return false
        }
      },

    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
    padding: 0;
  }

  .new-home-container {
    padding: 32px;

    .one-row {
      .one-row-1 {
        width: 816px;
        height: 180px;
        background-size: 100% 100%;
      }

      .one-row-2 {
        width: 396px;
        height: 180px;
        background: #292F3E;
        border-radius: 12px;

        .left-app {
          padding: 24px 0 24px 24px;

          .pp1 {
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
          }

          .pp2 {
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFFAA;
            margin: 4px 0 20px 0;
          }

          .pp3 {
            width: 100px;
            height: 32px;
            background: #FFFFFF33;
            border-radius: 6px;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 32px;
            text-align: center;
          }
        }

        .right-app {
          display: block;
          width: 187px;
          height: 161px;
        }
      }

      .one-row-3 {
      }

    }

    .two-row {
      .towRow-part {
        width: 816px;

        .title {
          margin: 32px 0 16px;
          font-weight: 500;
          font-size: 18px;
          color: #FAFAFA;
        }

        .all-info-box {
          height: 144px;
          background: #19202F;
          border-radius: 12px;
          padding: 0 12px;

          .every-info-box {
            width: 256px;
            height: 120px;
            background: #85889633;
            border-radius: 12px;
            position: relative;

            img {
              width: 121px;
              height: 104px;
            }

            .text-info-box {
              .text1 {
                font-weight: 500;
                font-size: 16px;
                color: #FAFAFA;
                margin-bottom: 2px;
              }

              .text2 {
                font-weight: 400;
                font-size: 12px;
                color: #FFFFFFAA;
              }

              .go-icon {
                display: block;
                width: 20px;
                height: 20px;
                margin-top: 8px;
              }
            }

            .jqqd-box {
              width: 84px;
              height: 43px;
              position: absolute;
              z-index: 1;
              top: 0;
              right: 0;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
</style>


<!--&lt;!&ndash;应用商店&ndash;&gt;-->
<!--<template>-->
<!--  <div class="store-container">-->
<!--    <div class="store-title" :style="{ color: theme.worksColor2 }">应用商店</div>-->

<!--    <div class="all-application flex ac fw">-->
<!--       <div class="every-application flex jb">-->
<!--         <div class="left-app">-->
<!--           <p class="pp1">创作数字分身视频</p>-->
<!--           <p class="pp2">一键创作另一个你的数字分身</p>-->
<!--           <p class="pp3 cr" @click="handleJump('/create')">立即创作</p>-->
<!--         </div>-->
<!--         <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic1.png" alt="">-->
<!--       </div>-->
<!--      <div class="every-application flex jb">-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">创作宠物视频</p>-->
<!--          <p class="pp2">毛孩专属片场，趣味视频轻松创造</p>-->
<!--          <p class="pp3 cr" @click="handleJump('/pet')">立即创作</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic2.png" alt="">-->
<!--      </div>-->
<!--      <div class="every-application flex jb">-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">视频翻译</p>-->
<!--          <p class="pp2">支持多国语言声音翻译对口型</p>-->
<!--          <p class="pp3 cr" @click="handleJump('/store/sea')">立即创作</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic3.png" alt="">-->
<!--      </div>-->
<!--      <div class="every-application flex jb">-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">照片说话</p>-->
<!--          <p class="pp2">可以让照片动起来的神奇工具</p>-->
<!--          <p class="pp3 cr" @click="handleJump('/store/imageSpeak')">立即创作</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic4.png" alt="">-->
<!--      </div>-->
<!--      <div class="every-application flex jb">-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">视频提取</p>-->
<!--          <p class="pp2">全网200+平台短视频无水印下载</p>-->
<!--          <p class="pp3 cr" @click="handleJump('/store/extraction')">立即提取</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic5.png" alt="">-->
<!--      </div>-->

<!--      <div class="every-application flex jb">-->
<!--        <div class="mo-ceng-box"></div>-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">文生图</p>-->
<!--          <p class="pp2">告别绘画零基础，文字也能成大师</p>-->
<!--          <p class="pp3 cr">即将上线</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic5.png" alt="">-->
<!--      </div>-->

<!--      <div class="every-application flex jb">-->
<!--        <div class="mo-ceng-box"></div>-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">文生视频</p>-->
<!--          <p class="pp2">文字跃然成画面，精彩视频即刻现</p>-->
<!--          <p class="pp3 cr">即将上线</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic5.png" alt="">-->
<!--      </div>-->

<!--      <div class="every-application flex jb">-->
<!--        <div class="mo-ceng-box"></div>-->
<!--        <div class="left-app">-->
<!--          <p class="pp1">图生视频</p>-->
<!--          <p class="pp2">静态瞬间动起来，精彩故事随心创</p>-->
<!--          <p class="pp3 cr">即将上线</p>-->
<!--        </div>-->
<!--        <img class="right-app" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.1_Pic5.png" alt="">-->
<!--      </div>-->



<!--      <div class="every-application more tc cr">-->
<!--        更多AI工具即将推出<br> 尽情期待…-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--  export default {-->
<!--    name: '',-->
<!--    data() {-->
<!--      return {}-->
<!--    },-->
<!--    computed: {-->
<!--      myHeaders() {-->
<!--        return {'x-token': window.localStorage.getItem('xcToken') || ''}-->
<!--      },-->
<!--      theme() {-->
<!--        return this.$store.getters.getTheme;-->
<!--      }-->
<!--    },-->
<!--    created() {-->
<!--    },-->
<!--    methods: {-->
<!--      handleJump(val){-->
<!--        this.$router.push({-->
<!--          path: val,-->
<!--          // query: {-->
<!--          //   redirectUrl: url-->
<!--          // }-->
<!--        })-->
<!--      }-->
<!--    },-->
<!--    /**加载完组件时执行(加载完成之后执行)*/-->
<!--    mounted() {-->
<!--    },-->
<!--  }-->
<!--</script>-->

<!--<style lang="scss" scoped>-->
<!--  .store-container {-->
<!--    padding: 30px;-->
<!--    .store-title {-->
<!--      font-weight: 500;-->
<!--      font-size: 24px;-->
<!--      color: #FFFFFF;-->
<!--    }-->
<!--  }-->
<!--  .all-application{-->
<!--     margin-top: 20px;-->
<!--    .every-application{-->
<!--      width: 389px;-->
<!--      height: 150px;-->
<!--      background: #19202F;-->
<!--      border-radius: 12px;-->
<!--      border: 1px solid rgba(255,255,255,0.1);-->
<!--      margin: 0 28px 28px 0;-->
<!--      position: relative;-->
<!--      .mo-ceng-box{-->
<!--        position: absolute;-->
<!--        z-index: 9;-->
<!--        width: 100%;-->
<!--        height: 100%;-->
<!--        background: #8F8C8C;-->
<!--        border-radius: 12px;-->
<!--        opacity: 0.5;-->
<!--        cursor: pointer;-->
<!--      }-->

<!--      p{-->
<!--        margin: 0;-->
<!--        padding: 0;-->
<!--      }-->
<!--      .left-app{-->
<!--        padding: 24px 0 24px 24px;-->
<!--        .pp1{-->
<!--          font-weight: 500;-->
<!--          font-size: 18px;-->
<!--          color: #FFFFFF;-->
<!--        }-->
<!--        .pp2{-->
<!--          font-weight: 400;-->
<!--          font-size: 12px;-->
<!--          color: #FFFFFFAA;-->
<!--          margin: 4px 0 20px 0;-->
<!--        }-->
<!--        .pp3{-->
<!--          width: 120px;-->
<!--          height: 36px;-->
<!--          background: #6C14FF;-->
<!--          border-radius: 6px;-->

<!--          font-weight: 500;-->
<!--          font-size: 14px;-->
<!--          color: #FFFFFF;-->
<!--          line-height: 36px;-->
<!--          text-align: center;-->
<!--        }-->
<!--      }-->

<!--      .right-app{-->
<!--        display: block;-->
<!--        width: 174px;-->
<!--        height: 150px;-->
<!--      }-->
<!--    }-->
<!--    .every-application:nth-child(4n){-->
<!--      margin-right: 0;-->
<!--    }-->
<!--    .more{-->
<!--      font-weight: 400;-->
<!--      font-size: 16px;-->
<!--      color: #FFFFFFAA;-->
<!--      line-height: 24px;-->
<!--      padding-top: 50px;-->
<!--    }-->
<!--  }-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/store.vue